/**
 * Color Control Component
 * Renders color picker
 */

import React from 'react';
import { Box, TextField, Typography } from '@mui/material';
import { ControlComponentProps } from '../../../../types/ControlTypes';
import { ColorSettings } from '../../../../types/ControlTypes';
import { LabelWithInfo } from './LabelWithInfo';

export const ColorControl: React.FC<ControlComponentProps> = ({
  name,
  value,
  onChange,
  error,
  disabled,
  readonly,
  label,
  description,
  required,
  control,
}) => {
  const settings = control.settings as ColorSettings;
  const format = settings?.format || 'hex';
  const allowAlpha = settings?.allowAlpha || false;

  return (
    <Box sx={{ mb: 2 }}>
      <Box sx={{ mb: 1 }}>
        <LabelWithInfo
          label={label || name}
          description={description}
          required={required}
        />
      </Box>
      
      <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
        {/* Color Input */}
        <input
          type="color"
          value={value || '#000000'}
          onChange={(e) => onChange(e.target.value)}
          disabled={disabled || readonly}
          style={{
            width: '60px',
            height: '40px',
            cursor: disabled || readonly ? 'not-allowed' : 'pointer',
            borderRadius: '4px',
            border: '1px solid #ddd',
            padding: '4px',
          }}
        />
        
        {/* Text Input for manual entry */}
        <TextField
          size="small"
          fullWidth
          value={value || ''}
          onChange={(e) => onChange(e.target.value)}
          placeholder={allowAlpha ? '#000000FF' : '#000000'}
          error={!!error}
          helperText={error}
          disabled={disabled || readonly}
          inputProps={{
            pattern: allowAlpha ? '^#[0-9A-Fa-f]{8}$' : '^#[0-9A-Fa-f]{6}$',
            maxLength: allowAlpha ? 9 : 7,
          }}
        />
      </Box>
      
      {/* Format info */}
      <Typography variant="caption" sx={{ color: '#999', mt: 0.5, display: 'block' }}>
        Format: {allowAlpha ? 'Hex with Alpha (#RRGGBBAA)' : 'Hex (#RRGGBB)'}
      </Typography>
    </Box>
  );
};

export default ColorControl;
